import { apiFetch, setToken } from "./api";

export async function signup(data) {
  const res = await apiFetch("/auth/signup", {
    method: "POST",
    body: JSON.stringify(data),
  });

  if (res.detail) {
    throw new Error(res.detail);
  }

  return res;
}


export async function submitMerchantApplication(data) {
  const res = await apiFetch("/merchant-applications", {
    method: "POST",
    body: JSON.stringify(data),
  });

  if (res.detail) {
    throw new Error(res.detail);
  }

  return res;
}

export async function verifyMerchantEmail(token) {
  const res = await apiFetch(`/auth/verify-email?token=${encodeURIComponent(token)}`);

  if (res.detail) {
    throw new Error(res.detail);
  }

  setToken(res.access_token);
  return res.user;
}

export async function resendMerchantVerification(data) {
  const res = await apiFetch("/auth/resend-verification", {
    method: "POST",
    body: JSON.stringify(data),
  });

  if (res.detail) {
    throw new Error(res.detail);
  }

  return res;
}

export async function login(data) {
  const res = await apiFetch("/auth/login", {
    method: "POST",
    body: JSON.stringify(data),
  });

  if (res.detail) {
    throw new Error(res.detail);
  }

  setToken(res.access_token);
  return res.user;
}

export async function getCurrentUser() {
  const res = await apiFetch("/auth/me");

  if (res.detail) {
    throw new Error(res.detail);
  }

  return res;
}